// extracted by mini-css-extract-plugin
export default {"container":"kiprjIGkltbM5kE1wlYN"};